import { render, staticRenderFns } from "./paymentsScreen.vue?vue&type=template&id=6cbf8ebd&scoped=true"
import script from "./paymentsScreen.vue?vue&type=script&lang=js"
export * from "./paymentsScreen.vue?vue&type=script&lang=js"
import style0 from "./paymentsScreen.vue?vue&type=style&index=0&id=6cbf8ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf8ebd",
  null
  
)

export default component.exports